import createActionType from "@/redux/utils/createActionType";

export const MODULE = "generate-pdf";

export const SET_IS_GENERATING_PREVIEW_PDF_STATUS = createActionType(
  MODULE,
  "setIsGeneratingPreviewPdfStatus"
);

export const RESET = createActionType(MODULE, "reset");
